export enum CertificationStatus {
Active,
Inactive,
}
